<template>
  <div class="bottom-panel-padding">
    <div
      class="row gutters-sm"
    >
      <div class="col-auto">
        <h3>Custom Properties</h3>
      </div>
      <div
        class="ml-auto"
      >
        <b-button
          @click="submitCustomProperties"
          variant="primary"
          data-test="custom-properties-submit-button"
          :class="{ 'btn-loading': isLoading }"
          :disabled="isCampaignReadonly"
        >
          Save
        </b-button>
      </div>
    </div>
    <b-row
      v-for="(row, index) in rows"
      :key="index"
    >
      <b-col sm="4">
        <b-form-select
          v-model="row.type"
          class="mb-3"
          :id="`custom-property-name-${index}`"
          :disabled="isCampaignReadonly"
        >
          <b-form-select-option
            v-for="(type, i) in customPropertyTypes"
            :value="type"
            :key="i"
          >
            {{ type }}
          </b-form-select-option>
        </b-form-select>
      </b-col>
      <b-col sm="6">
        <b-form-input
          v-model="row.value"
          :id="`custom-property-value-${index}`"
          :read-only="isCampaignReadonly"
        />
      </b-col>
      <b-col sm="auto">
        <!-- <i
          class="fa fa-trash-can fa-2x"
          @click="removeVariableRow(index)"
        /> -->
        <button
          type="button"
          class="btn btn-icon btn-danger"
          :id="`custom-property-delete-btn-${index}`"
          @click="removeVariableRow(index)"
        >
          <i class="fa-light fa-trash-can" />
        </button>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="2">
        <b-button
          id="addVariable"
          @click="addVariableRow"
          variant="secondary"
          :disabled="isCampaignReadonly"
        >
          Add variable
        </b-button>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import * as types from '@/modules/content/store/types';
import * as campaignTypes from '@/modules/campaigns/store/types';

import helper from '@/core/helper';

export default {
  name: 'CustomPropertiesPanel',
  data() {
    return {
      isLoading: false,
      customPropertyTypes: [],
      rows: [],
    };
  },
  props: {
    encodedExternalId: {
      type: String,
      default: '',
    },
    advertisersId: {
      type: Number,
      default: 0,
    },
    creative: {
      type: Object,
      default: null,
    },
  },
  computed: {
    ...mapState('campaigns', [
      'selectedAdvertiser',
    ]),
    ...mapGetters('campaigns', {
      isCampaignReadonly: campaignTypes.GET_IS_CAMPAIGN_READONLY,
    }),
    ...mapState('content', [
      'contentItemsDisplayProperties',
      'selectedArticleUuid',
      'selectedCreativeId',
      'allDisplayCopy',
    ]),
  },
  methods: {
    ...mapActions('content', [
      types.FETCH_CUSTOM_PROPERTY_TYPES,
      types.SAVE_CUSTOM_PROPERTIES,
    ]),
    submitCustomProperties() {
      this.isLoading = true;

      const typesChosen = [];
      let typeExists = false;

      this.rows.forEach((row) => {
        if (typesChosen.includes(row.type)) {
          typeExists = true;
          return;
        }
        typesChosen.push(row.type);
      });

      if (!typeExists) {
        this.isLoading = false;

        const payload = {
          customPropertyTypes: this.customPropertyTypes,
          rows: this.rows,
          encodedExternalId: this.encodedExternalId,
        };

        this.SAVE_CUSTOM_PROPERTIES(payload).then(() => {});
      }
    },
    updateCustomProperties() {
      this.rows = [];
      if (!this.customPropertyTypes
        || !helper.objLength(this.contentItemsDisplayProperties)
        || !this.selectedCreativeId
        || !helper.objLength(this.contentItemsDisplayProperties[this.selectedCreativeId])) return [];

      const selectedArticleDisplayProperties = this.contentItemsDisplayProperties[this.selectedCreativeId][this.selectedArticleUuid]?.displayProperties;
      for (const key in selectedArticleDisplayProperties) {
        if (this.customPropertyTypes.includes(key)) {
          this.rows.push({
            type: key,
            value: selectedArticleDisplayProperties[key],
          });
        }
      }
    },
    getCustomPropertyTypes() {
      this.FETCH_CUSTOM_PROPERTY_TYPES().then((customPropertyTypes) => {
        this.customPropertyTypes = customPropertyTypes.filter((type) => type !== '');
      });
    },
    addVariableRow() {
      this.rows.push({ type: '', value: '' });
      const articleElement = document.getElementById('addVariable');
      setTimeout(() => {
        articleElement.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'end' });
      }, 300);
    },
    removeVariableRow(index) {
      this.rows.splice(index, 1);
    },
  },
  mounted() {
    this.getCustomPropertyTypes();
  },
  watch: {
    customPropertyTypes() {
      this.updateCustomProperties();
    },
    creative() {
      this.updateCustomProperties();
    },
    encodedExternalId() {
      this.updateCustomProperties();
    },
  },
};
</script>
